import React, { useEffect, useState } from "react";
import { Box, Typography, Avatar } from "@mui/material";
import DobbyHeroSvg from "../components/DobbyHeroSvg";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useQueryParam } from "../utils/url";
import { createGlobalStyle } from "styled-components";

const BodyStyles = createGlobalStyle`
  body {
    height: 100vh;
    overflow: hidden;
  }

  #root {
    height: 100%;
  }
`;

// share with desktop code
interface WidgetState {
  displayState: {
    params: { bubbleMessage: string };
    size: "maximized" | "minimized" | "icon_only";
  };
}

const TestWidgetPage: React.FC = () => {
  const widgetInitialState: WidgetState = JSON.parse(
    useQueryParam("initial_widget_state") as any
  );
  const [widgetState, setWidgetState] =
    useState<WidgetState>(widgetInitialState);

  useEffect(() => {
    const handleMessage = (event: any) => {
      const { type, payload } = event.data || {};
      if (type === "state_update") {
        setWidgetState(payload);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  console.log(widgetState);
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        pr: "20px",
        pl: "17px",
        boxSizing: "border-box",
        bgcolor: "transparent",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        backgroundColor:
          widgetState.displayState.size === "maximized"
            ? "rgba(36,28,28,0.5)"
            : "transparent",
        border:
          widgetState.displayState.size === "maximized"
            ? "1px solid rgba(255,255,255,0.5)"
            : "none",
        borderRadius: 4,
      }}
    >
      {widgetState.displayState.size === "maximized" && (
        <IconButton
          size="small"
          sx={{
            position: "absolute",
            top: 4,
            left: 4,
            backgroundColor: "#4A4A4A",
            color: "#FFFFFF",
          }}
          onClick={() => {
            window.parent.postMessage("minimize", "*");
          }}
        >
          <CloseIcon fontSize="small" sx={{ fontSize: 12 }} />
        </IconButton>
      )}
      <ChatBubble
        showBubble={widgetState.displayState.size !== "icon_only"}
        onClick={() => {
          if (widgetState.displayState.size === "minimized") {
            window.parent.postMessage("maximize", "*");
          }
        }}
        message={widgetState.displayState.params.bubbleMessage}
        avatarSrc="path/to/avatar.png"
      />
    </Box>
  );
};

export default TestWidgetPage;

interface ChatBubbleProps {
  message: string;
  avatarSrc: string;
  onClick: () => void;
  showBubble: boolean;
}

const ChatBubble: React.FC<ChatBubbleProps> = ({
  message,
  avatarSrc,
  onClick,
  showBubble,
}) => {
  return (
    <Box
      display="flex"
      pt={"4px"}
      alignItems="flex-start"
      bgcolor="transparent"
      sx={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <BodyStyles />
      {showBubble && (
        <Box
          sx={{
            bgcolor: "#4A4A4A",
            color: "#FFFFFF",
            px: 1.5,
            py: 1,
            borderRadius: "16px",
            maxWidth: 300,
            fontSize: 14,
            lineHeight: 1.4,
          }}
        >
          <Typography variant="body2">{message}</Typography>
        </Box>
      )}
      <Box ml={1.5}>
        <Avatar
          src={avatarSrc}
          sx={{ width: 44, height: 44, bgcolor: "transparent" }}
        >
          <DobbyHeroSvg width={44} height={44} fill="#FEDF33" />
        </Avatar>
      </Box>
    </Box>
  );
};
